const PREFIX = '@entry';

export default {
  PREFIX,

  /* Login */

  AUTHENTICATE: `${PREFIX}/AUTHENTICATE`,
  AUTHENTICATE_ERROR_CLEAR: `${PREFIX}/AUTHENTICATE_ERROR_CLEAR`,
  LOGOUT: `${PREFIX}/LOGOUT`,

  /* Socket */

  SOCKET_DISCONNECT_HANDLE: `${PREFIX}/SOCKET_DISCONNECT_HANDLE`,
  SOCKET_RECONNECT_HANDLE: `${PREFIX}/SOCKET_RECONNECT_HANDLE`,

  /* Modal */

  MODAL_OPEN: `${PREFIX}/MODAL_OPEN`,
  MODAL_CLOSE: `${PREFIX}/MODAL_CLOSE`,

  /* User */

  USER_CREATE: `${PREFIX}/USER_CREATE`,
  USER_CREATE_ERROR_CLEAR: `${PREFIX}/USER_CREATE_ERROR_CLEAR`,
  USER_UPDATE: `${PREFIX}/USER_UPDATE`,
  CURRENT_USER_UPDATE: `${PREFIX}/CURRENT_USER_UPDATE`,
  CURRENT_USER_EMAIL_UPDATE: `${PREFIX}/CURRENT_USER_EMAIL_UPDATE`,
  CURRENT_USER_EMAIL_UPDATE_ERROR_CLEAR: `${PREFIX}/CURRENT_USER_EMAIL_UPDATE_ERROR_CLEAR`,
  CURRENT_USER_PASSWORD_UPDATE: `${PREFIX}/CURRENT_USER_PASSWORD_UPDATE`,
  CURRENT_USER_PASSWORD_UPDATE_ERROR_CLEAR: `${PREFIX}/CURRENT_USER_PASSWORD_UPDATE_ERROR_CLEAR`,
  CURRENT_USER_USERNAME_UPDATE: `${PREFIX}/CURRENT_USER_USERNAME_UPDATE`,
  CURRENT_USER_USERNAME_UPDATE_ERROR_CLEAR: `${PREFIX}/CURRENT_USER_USERNAME_UPDATE_ERROR_CLEAR`,
  CURRENT_USER_AVATAR_UPDATE: `${PREFIX}/CURRENT_USER_AVATAR_UPDATE`,
  USER_DELETE: `${PREFIX}/USER_DELETE`,
  USER_TO_DEVICE_ADD: `${PREFIX}/USER_TO_DEVICE_ADD`,
  USER_TO_CURRENT_DEVICE_ADD: `${PREFIX}/USER_TO_CURRENT_DEVICE_ADD`,
  USER_FROM_DEVICE_REMOVE: `${PREFIX}/USER_FROM_DEVICE_REMOVE`,
  USER_FROM_CURRENT_DEVICE_REMOVE: `${PREFIX}/USER_FROM_CURRENT_DEVICE_REMOVE`,
  USER_TO_FILTER_IN_CURRENT_SITE_ADD: `${PREFIX}/USER_TO_FILTER_IN_CURRENT_SITE_ADD`,
  USER_FROM_FILTER_IN_CURRENT_SITE_REMOVE: `${PREFIX}/USER_FROM_FILTER_IN_CURRENT_SITE_REMOVE`,

  /* Factory */

  FACTORY_CREATE: `${PREFIX}/FACTORY_CREATE`,
  FACTORY_UPDATE: `${PREFIX}/FACTORY_UPDATE`,
  FACTORY_DELETE: `${PREFIX}/FACTORY_DELETE`,
  CURRENT_FACTORY_UPDATE: `${PREFIX}/CURRENT_FACTORY_UPDATE`,
  CURRENT_FACTORY_BACKGROUND_IMAGE_UPDATE: `${PREFIX}/CURRENT_FACTORY_BACKGROUND_IMAGE_UPDATE`,
  CURRENT_FACTORY_DELETE: `${PREFIX}/CURRENT_FACTORY_DELETE`,

  /* Brand */

  BRAND_CREATE: `${PREFIX}/BRAND_CREATE`,
  CURRENT_BRAND_UPDATE: `${PREFIX}/CURRENT_BRAND_UPDATE`,
  CURRENT_BRAND_DELETE: `${PREFIX}/CURRENT_BRAND_DELETE`,

  /* Model */

  MODEL_CREATE: `${PREFIX}/MODEL_CREATE`,
  MODEL_UPDATE: `${PREFIX}/MODEL_UPDATE`,
  MODEL_DELETE: `${PREFIX}/MODEL_DELETE`,
  CURRENT_MODEL_UPDATE: `${PREFIX}/CURRENT_MODEL_UPDATE`,
  CURRENT_MODEL_DELETE: `${PREFIX}/CURRENT_MODEL_DELETE`,

  /* Diagram */

  DIAGRAM_CREATE: `${PREFIX}/DIAGRAM_CREATE`,
  DIAGRAM_UPDATE: `${PREFIX}/DIAGRAM_UPDATE`,
  DIAGRAM_DELETE: `${PREFIX}/DIAGRAM_DELETE`,

  /* Protocol */

  PROTOCOL_CREATE: `${PREFIX}/PROTOCOL_CREATE`,
  PROTOCOL_UPDATE: `${PREFIX}/PROTOCOL_UPDATE`,
  PROTOCOL_DELETE: `${PREFIX}/PROTOCOL_DELETE`,
  CURRENT_PROTOCOL_UPDATE: `${PREFIX}/CURRENT_PROTOCOL_UPDATE`,
  CURRENT_PROTOCOL_DELETE: `${PREFIX}/CURRENT_PROTOCOL_DELETE`,

  /* Protocol */

  ALERT_SETTING_CREATE: `${PREFIX}/ALERT_SETTING_CREATE`,
  ALERT_SETTING_UPDATE: `${PREFIX}/ALERT_SETTING_UPDATE`,
  ALERT_SETTING_DELETE: `${PREFIX}/ALERT_SETTING_DELETE`,
  CURRENT_ALERT_SETTING_UPDATE: `${PREFIX}/CURRENT_ALERT_SETTING_UPDATE`,
  CURRENT_ALERT_SETTING_DELETE: `${PREFIX}/CURRENT_ALERT_SETTING_DELETE`,

  /* Channel */

  CHANNEL_CREATE: `${PREFIX}/CHANNEL_CREATE`,
  CHANNEL_UPDATE: `${PREFIX}/CHANNEL_UPDATE`,
  CHANNEL_DELETE: `${PREFIX}/CHANNEL_DELETE`,
  CURRENT_CHANNEL_UPDATE: `${PREFIX}/CURRENT_CHANNEL_UPDATE`,
  CURRENT_CHANNEL_DELETE: `${PREFIX}/CURRENT_CHANNEL_DELETE`,

  /* Channel */

  ITEM_CREATE: `${PREFIX}/ITEM_CREATE`,
  ITEM_UPDATE: `${PREFIX}/ITEM_UPDATE`,
  ITEM_DELETE: `${PREFIX}/ITEM_DELETE`,
  CURRENT_ITEM_UPDATE: `${PREFIX}/CURRENT_ITEM_UPDATE`,
  CURRENT_ITEM_DELETE: `${PREFIX}/CURRENT_ITEM_DELETE`,

  /* Factory membership */

  MEMBERSHIP_IN_CURRENT_FACTORY_CREATE: `${PREFIX}/MEMBERSHIP_IN_CURRENT_FACTORY_CREATE`,
  FACTORY_MEMBERSHIP_DELETE: `${PREFIX}/FACTORY_MEMBERSHIP_DELETE`,

  /* Site */

  SITE_IN_CURRENT_FACTORY_CREATE: `${PREFIX}/SITE_IN_CURRENT_FACTORY_CREATE`,
  SITE_FETCH: `${PREFIX}/SITE_FETCH`,
  SITE_UPDATE: `${PREFIX}/SITE_UPDATE`,
  SITE_MOVE: `${PREFIX}/SITE_MOVE`,
  SITE_DELETE: `${PREFIX}/SITE_DELETE`,

  /* Label */

  LABEL_IN_CURRENT_SITE_CREATE: `${PREFIX}/LABEL_IN_CURRENT_SITE_CREATE`,
  LABEL_UPDATE: `${PREFIX}/LABEL_UPDATE`,
  LABEL_DELETE: `${PREFIX}/LABEL_DELETE`,
  LABEL_TO_DEVICE_ADD: `${PREFIX}/LABEL_TO_DEVICE_ADD`,
  LABEL_TO_CURRENT_DEVICE_ADD: `${PREFIX}/LABEL_TO_CURRENT_DEVICE_ADD`,
  LABEL_FROM_DEVICE_REMOVE: `${PREFIX}/LABEL_FROM_DEVICE_REMOVE`,
  LABEL_FROM_CURRENT_DEVICE_REMOVE: `${PREFIX}/LABEL_FROM_CURRENT_DEVICE_REMOVE`,
  LABEL_TO_FILTER_IN_CURRENT_SITE_ADD: `${PREFIX}/LABEL_TO_FILTER_IN_CURRENT_SITE_ADD`,
  LABEL_FROM_FILTER_IN_CURRENT_SITE_REMOVE: `${PREFIX}/LABEL_FROM_FILTER_IN_CURRENT_SITE_REMOVE`,

  /* Line */

  LINE_IN_CURRENT_SITE_CREATE: `${PREFIX}/LINE_IN_CURRENT_SITE_CREATE`,
  LINE_UPDATE: `${PREFIX}/LINE_UPDATE`,
  LINE_MOVE: `${PREFIX}/LINE_MOVE`,
  LINE_DELETE: `${PREFIX}/LINE_DELETE`,

  /* Device */

  DEVICE_CREATE: `${PREFIX}/DEVICE_CREATE`,
  DEVICE_UPDATE: `${PREFIX}/DEVICE_UPDATE`,
  DEVICE_COMMON_UPDATE: `${PREFIX}/DEVICE_COMMON_UPDATE`,
  DEVICE_HIDE: `${PREFIX}/DEVICE_HIDE`,
  CURRENT_DEVICE_UPDATE: `${PREFIX}/CURRENT_DEVICE_UPDATE`,
  DEVICE_MOVE: `${PREFIX}/DEVICE_MOVE`,
  CURRENT_DEVICE_MOVE: `${PREFIX}/CURRENT_DEVICE_MOVE`,
  DEVICE_TRANSFER: `${PREFIX}/DEVICE_TRANSFER`,
  CURRENT_DEVICE_TRANSFER: `${PREFIX}/CURRENT_DEVICE_TRANSFER`,
  DEVICE_DELETE: `${PREFIX}/DEVICE_DELETE`,
  CURRENT_DEVICE_DELETE: `${PREFIX}/CURRENT_DEVICE_DELETE`,
  FETCH_DATA_REALTIME: `${PREFIX}/FETCH_DATA_REALTIME`,

  /* Alarm */

  ALARM_IN_CURRENT_DEVICE_CREATE: `${PREFIX}/ALARM_IN_CURRENT_DEVICE_CREATE`,
  ALARM_UPDATE: `${PREFIX}/ALARM_UPDATE`,
  ALARM_DELETE: `${PREFIX}/ALARM_DELETE`,

  /* Attachment */

  ATTACHMENT_DEVICE_CREATE: `${PREFIX}/ATTACHMENT_DEVICE_CREATE`,
  ATTACHMENT_IN_CURRENT_DEVICE_CREATE: `${PREFIX}/ATTACHMENT_IN_CURRENT_DEVICE_CREATE`,
  ATTACHMENT_UPDATE: `${PREFIX}/ATTACHMENT_UPDATE`,
  ATTACHMENT_DELETE: `${PREFIX}/ATTACHMENT_DELETE`,
  ATTACHMENT_MODEL_CREATE: `${PREFIX}/ATTACHMENT_MODEL_CREATE`,
  ATTACHMENT_MODEL_UPDATE: `${PREFIX}/ATTACHMENT_MODEL_UPDATE`,
  ATTACHMENT_MODEL_DELETE: `${PREFIX}/ATTACHMENT_MODEL_DELETE`,

  /* Architecture */

  ARCHITECTURE_CREATE: `${PREFIX}/ARCHITECTURE_CREATE`,
  ARCHITECTURE_DELETE: `${PREFIX}/ARCHITECTURE_DELETE`,
  ARCHITECTURE_FETCH: `${PREFIX}/ARCHITECTURE_FETCH`,

  /* Actions */

  ACTIONS_IN_CURRENT_DEVICE_FETCH: `${PREFIX}/ACTIONS_IN_CURRENT_DEVICE_FETCH`,

  /* Comment action */

  COMMENT_ACTION_IN_CURRENT_DEVICE_CREATE: `${PREFIX}/COMMENT_ACTION_IN_CURRENT_DEVICE_CREATE`,
  COMMENT_ACTION_UPDATE: `${PREFIX}/COMMENT_ACTION_UPDATE`,
  COMMENT_ACTION_DELETE: `${PREFIX}/COMMENT_ACTION_DELETE`,

  /* Notification */

  NOTIFICATION_DELETE: `${PREFIX}/NOTIFICATION_DELETE`,

  /* Alerts */

  ALERT_DISPLAYED: `${PREFIX}/ALERT_DISPLAYED`,
  ALERT_DATA: `${PREFIX}/ALERT_DATA`,

  /* Reports */
  DAILY_REPORTS_FETCH_REQUEST: `${PREFIX}/DAILY_REPORTS_FETCH_REQUEST`,
  MONTHLY_REPORTS_FETCH_REQUEST: `${PREFIX}/MONTHLY_REPORTS_FETCH_REQUEST`,
  YEARLY_REPORTS_FETCH_REQUEST: `${PREFIX}/YEARLY_REPORTS_FETCH_REQUEST`,
  CURRENT_REPORTS_FETCH_REQUEST: `${PREFIX}/CURRENT_REPORTS_FETCH_REQUEST`,

  /* Dashboard */
  FETCH_DASHBOARD: `${PREFIX}/FETCH_DASHBOARD`,

  /* Invoices */
  INVOICES_ELECTRICITY_FETCH_REQUEST: `${PREFIX}/INVOICES_ELECTRICITY_FETCH_REQUEST`,
  INVOICES_GAS_FETCH_REQUEST: `${PREFIX}/INVOICES_GAS_FETCH_REQUEST`,
  INVOICES_WATER_FETCH_REQUEST: `${PREFIX}/INVOICES_WATER_FETCH_REQUEST`,

  /* Setting Prices */
  SETTING_PRICE_CREATE: `${PREFIX}/SETTING_PRICE_CREATE`,
  SETTING_PRICE_UPDATE: `${PREFIX}/SETTING_PRICE_UPDATE`,

  /* Settings emails */
  SETTING_EMAILS_CREATE: `${PREFIX}/SETTING_EMAILS_CREATE`,
  SETTING_EMAILS_UPDATE: `${PREFIX}/SETTING_EMAILS_UPDATE`,

  /* Component */
  COMPONENT_CREATE: `${PREFIX}/COMPONENT_CREATE`,
  COMPONENT_UPDATE: `${PREFIX}/COMPONENT_UPDATE`,
  COMPONENT_DELETE: `${PREFIX}/COMPONENT_DELETE`,

  /* Diagram */
  FETCH_DIAGRAM: `${PREFIX}/FETCH_DIAGRAM`,

  /* System */
  REBOOT_SYSTEM: `${PREFIX}/REBOOT_SYSTEM`,
};
